<template>
  <div>
    Delete Presence
  </div>
</template>
<script>
export default {
  data() {
    return {
      list: []
    };
  }
};
</script>
